"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var SendOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_SendOutline_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 16,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.458 2.009 1.234 2a.2.2 0 0 0-.13.038.268.268 0 0 0-.086.125.29.29 0 0 0-.011.162c.01.04.03.084.087.131l3.293 2.745a.62.62 0 0 0 .596.114l3.494-1.172c.77-.258 1.433.17 1.703.7.267.528.225 1.303-.412 1.781l-2.96 2.224a.684.684 0 0 0-.267.593l.295 4.322a.25.25 0 0 0 .054.153c.028.032.069.06.12.074.05.015.096.012.13 0 .028-.009.068-.03.112-.092L14.893 2.91c.28-.402-.026-.902-.435-.902Zm-8.251 6.04c-.452.339-.702.89-.664 1.46l.295 4.322c.08 1.176 1.565 1.6 2.235.638l7.641-10.987c.722-1.037-.006-2.472-1.255-2.473L1.235 1C.077 1-.442 2.477.454 3.224L3.746 5.97a1.62 1.62 0 0 0 1.555.294l3.494-1.172c.443-.149.748.451.372.734l-2.96 2.223Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_SendOutline_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = SendOutline;
exports["default"] = _default;